// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"196":"component---src-templates-article-js","293":"component---src-pages-index-js","502":"component---src-templates-tag-js"}[chunkId] || chunkId) + "-" + {"196":"230f7f1224213fd89564","293":"6eef22fdf6bf03498bbc","454":"1fec03583fabd35cfca0","502":"ff8c92f86f828b09a793"}[chunkId] + ".js";
};